import axios from '../../axios/index.js'

export default {
    //Ehs
    ehsStatus(){
        return axios.get('/dashboard/ehsDonut')
    },
    ehsData(data){
        return axios.get('/dashboard/ehsTable', { params:data } )
    },
    fullEhsData(data){
        return axios.get('/dashboard/ehsFullTable', { params:data } )
    },
    ehsDetails(ehsId){
        return axios.get('/dashboard/ehsDetails',{ params:{ ehsId } })
    },
    //Compliance
    complianceDonut(){
        return axios.get('/dashboard/complianceDonut')
    },
    complianceData(data){
        return axios.get('/dashboard/complianceTable', { params:data } )
    },
    fullComplianceData(data){
        return axios.get('/dashboard/complianceFullTable', { params:data } )
    },
    //Expenses
    pendingExpenseDonut(){
        return axios.get('/dashboard/pendingExpenses')
    },
    pendingExpenseData(){
        return axios.get('/dashboard/pendingExpenses')
    },
    invoicedExpenseDonut(){
        return axios.get('/dashboardtv/invoicedExpenses')
    },
    invoicedExpenseData(){
        return axios.get('/dashboard/invoicedExpenses')
    },
    expenseDetails(id){
        return axios.get('/dashboard/expenseDetails', { params:{ id } })
    },
    ExpenseDataTable(data){
        return axios.get('/dashboard/statusExpenses', { params:data })
    },
    fullExpenseDataTable(data){
        return axios.get('/dashboard/expenseFullTable', { params:data })
    },
    //Warehouse
    palletWarehouseDonut(){
        return axios.get('/dashboard/donutPalletsWarehouse')
    },
    EntriDataTable(data){
        return axios.get('/dashboard/tablePalletsWarehouse', { params:data })
    },
    fullEntriDataTable(data){
        return axios.get('/dashboard/entryFullTable', { params:data })
    },
    showEntrie(id) {
        return axios.get('dashboard/entries/show/' + id)
    },
    getContainers(id) {
        return axios.get('dashboard/entries/get_containers/' + id)
    },
    getReviewOrder(id) {
        return axios.get('dashboard/entries/get_review_order/' + id)
    },
    getInvoiceList(id) {
        return axios.get('dashboard/entries/get_invoices_list/' + id)
    },
    getLoadOrder(id) {
        return axios.get('dashboard/entries/get_load_order/' + id)
    },
    getEntrieFiles(id) {
        return axios.get('dashboard/entries/get_entry_files/' + id)
    },
    getContainerTypes() {
        return axios.get('dashboard/entries/containerTypes')
    },
    timeline(entry_id){
        return axios.get('dashboard/entries/timeline/'+entry_id)
    },
    //Headcount
    headcountCard(){
        return axios.get('recruitment/headcount/card')
    },
    headcountList(data){
        return axios.get('recruitment/headcount/list', { params:data })
    },
    //Directos
    directCard(){
        return axios.get('direct/card')
    },
    directList(data){
        return axios.get('direct/list', { params:data })
    },
    directShow(id){
        return axios.get('direct/show/' + id)
    },
    directUpdate(id,data){
        return axios.post('direct/update/' + id , data  )
    },

    //Indirectos
    indirectCard(){
        return axios.get('indirect/card')
    },
    indirectList(data){
        return axios.get('indirect/list', { params:data })
    },
    indirectShow(id){
        return axios.get('indirect/show/' + id)
    },
    indirectFile(){
        return axios.get('indirect/documents/files')
    },
    indirectAspirant(id){
        return axios.get('indirect/aspirant/data/'+id)
    },
    //complementarys
    complementaryCard(){
        return axios.get('complementary/payrolls/card')
    },
    complementaryList(){
        return axios.get('complementary/payrolls/list')
    },
    getClients(data) {
        return axios.get('dashboard/cells/clients', { params: data })
    },
    getUsers(data) {
        return axios.get('dashboard/cells/users', { params: data })
    },
    getCellList(data) {
        return axios.get('dashboard/cells/list', { params: data })
    },
    getCell(data) {
        return axios.get('dashboard/cells/show', { params: data })
    },
    saveCell(data) {
        return axios.post('dashboard/cells/save', data )
    },
    updateCell(data) {
        return axios.post('dashboard/cells/update', data )
    },
    deleteCell(data) {
        return axios.get('dashboard/cells/delete', { params: data })
    },
    indirectDetails(id){
        return axios.get('/indirect/show/' + id)
    },
    indirectFiles(id){
        return axios.get('indirect/documents/files',{
            params: {
              foreing_key: id
            }
          })
    },
    indirectAspirantData(id){
        return axios.get('indirect/aspirant/data' + id)
    },
    complementaryPayrollsTable(data){
        return axios.get('complementary/payrolls/list', { params:data })
    },
    getCellId(data) {
        return axios.get('dashboard/cells/getId', { params: data })
    },

}
